module.exports = __webpack_public_path__ + "static/media/vip_cover_icon.9189322b.svg";